import { RoleBaseDesignThemeSizeConfig } from './types';

const medium: RoleBaseDesignThemeSizeConfig = {
  roleBaseDesign: {},
};

export default medium;
